//NOTE: convertHexToRGB function is great option, when design has backgrounds or colors with opacity style.
//usage of this function: convertHexToRGB(black, 0.5), this will give us a black color with 50% opacity.
export const convertHexToRGB = (hex: string, tint?: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (tint) {
    return `rgba(${r}, ${g}, ${b}, ${tint})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
};

// System Colors
export const black = "#000000";
export const black50 = convertHexToRGB("#39353C", 0.04);
export const black100 = convertHexToRGB("#39353C", 0.08);
export const black200 = convertHexToRGB("#39353C", 0.16);
export const black400 = convertHexToRGB("#39353C", 0.4);
export const blue = "#00a8ff";
export const blueDark = "#185079";
export const brightGrey = "#F3F0EB";
export const lightGreen = "#0f0";
export const green = "#129C4A";
export const gold = "#FFD700";
export const orange = "#e84118";
export const purple = "#9767BD";
export const purpleLight = "#9c88ff";
export const purpleStrong = "#664A71";
export const red = "#EF543B";
export const teal = "#008080";
export const yellow = "#F8CF46";

// Text Colors
export const textBlack = "#39353C";
export const textGrey = "#999C9F";
export const textGrey600 = convertHexToRGB("#39353C", 0.64);
export const textWhite = "#f5f6fa";
export const darkCyan = "#00878A";

// Background Colors
export const white = "#FFFFFF";
export const romance = "#F3F0EB";
export const lightGrey = "#E5E5E5";
export const darkViolet = "#2A2A47";